namespace $ {

	$mol_style_attach( '$shm_agent_message_text_style', `
		[shm_agent_message_text] {
			min-width: 0;
			white-space: pre-wrap;
			word-break: break-word;
		}

		[shm_agent_message_text] [mol_text_paragraph],
		[shm_agent_message_text] [mol_text_header] {
			padding: 0;
		}

		[shm_agent_message_text] [mol_text_table_cell] {
			padding-left: .5rem;
			padding-right: .5rem;
		}

		[shm_agent_message_text] [mol_text_link_http],
		[shm_agent_message_text] [mol_text_link] {
			white-space: normal;
			overflow-wrap: anywhere;
		}

		[shm_agent_message_text_chart_invalid] {
			flex-direction: column;
			gap: .5rem;
		}

		[shm_agent_message_text_chart_error] {
			color: var(--shm_theme_error);
			padding: .5rem;
		}
	` )

}
